import React, { useEffect, useRef, useState } from 'react';

/**
 * Telegram Login widget — redirect mode (data-auth-url).
 * Renders nothing if botUsername is missing (e.g. dev-only local bypass without a bot).
 */
export default function TelegramLoginWidget({ botUsername }) {
  const containerRef = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!botUsername || !containerRef.current) return undefined;

    const el = containerRef.current;
    el.innerHTML = '';

    const authCallbackUrl = `${window.location.origin}/api/auth/telegram/widget-callback`;

    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://telegram.org/js/telegram-widget.js?23';
    script.setAttribute('data-telegram-login', botUsername);
    script.setAttribute('data-size', 'large');
    script.setAttribute('data-auth-url', authCallbackUrl);
    script.setAttribute('data-request-access', 'write');
    el.appendChild(script);

    // Trigger fade-in + slide-up after a short delay
    const t = setTimeout(() => setVisible(true), 100);

    return () => {
      el.innerHTML = '';
      clearTimeout(t);
    };
  }, [botUsername]);

  if (!botUsername) return null;

  return (
    <div
      ref={containerRef}
      className="flex justify-center min-h-[40px]"
      style={{
        opacity: visible ? 1 : 0,
        transform: visible ? 'translateY(0)' : 'translateY(12px)',
        transition: 'opacity 0.6s ease-out, transform 0.6s ease-out',
      }}
    />
  );
}
